module.exports = __webpack_public_path__ + "media/images/icons/flags/AT-05b71ebbf0457edb2a594db833e57bf4.svg";